// extracted by mini-css-extract-plugin
export var campaignContainer = "n_p5 d_dS";
export var campaignContainerFull = "n_p6 d_dQ";
export var wrapper = "n_p7 d_s";
export var leftWrapper = "n_p8 d_bw d_bK";
export var rightWrapper = "n_p9";
export var subtitle = "n_qb";
export var title = "n_qc";
export var text = "n_p1 d_cp";
export var inlineWrapper = "n_qd d_by d_bC d_s";
export var btnsWrapper = "n_qf n_qd d_by d_bC d_s d_bF";
export var priceWrapper = "n_qg n_qd d_by d_bC d_s d_cd d_bL";
export var priceHeading = "n_qh";
export var disclaimerWrapper = "n_qj d_cz";
export var mediaSlot = "n_qk";
export var listWrapper = "n_ql d_by d_bL d_s";
export var btnWrapper = "n_dZ";
export var imageWrapper = "n_qm d_fc d_W";
export var SmallSmall = "n_qn x_qn x_rM x_r7";
export var SmallNormal = "n_qp x_qp x_rM x_r8";
export var SmallLarge = "n_qq x_qq x_rM x_r5";